'use client';

import { navigationItemActiveStyle, navigationItemStyle } from './navigationItemStyles';
import { Box, IconButton, List, ListItemButton, ListItemText } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React, { ReactElement } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useMatchRoutes } from './useMatchRoutes';
import { VerticalDivider } from '@efacity/react-next-sc';
import { navigateToPage } from './navigateToPage';
import { MenuItemType } from './interfaces';
import { NavigationItem, PlainNavigationItem } from './leftNavigationHelpers';

export function NavigationItemReact({ navigationItem }: { navigationItem: NavigationItem }): ReactElement {
  const navigate = useNavigate();
  const isLinkActive = useMatchRoutes((navigationItem as PlainNavigationItem)?.matchPaths || []);

  const onNavigateToAddPage = (path: string) => (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    navigateToPage(navigate)(path);
  };

  if (navigationItem.type === MenuItemType.DIVIDER) {
    return <hr key={'divider_key'} style={{ marginTop: 2, marginBottom: 2 }} />;
  }

  return (
    <List component="nav" style={{ padding: 0 }}>
      <Box display="flex" key={'ActivitiesNavigationLinkKey'}>
        <ListItemButton
          component={NavLink}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          sx={({ isActive }) =>
            isActive || isLinkActive ? { ...navigationItemActiveStyle, ...navigationItemStyle } : navigationItemStyle
          }
          to={navigationItem.link}
        >
          <ListItemText primary={navigationItem.label} style={{ margin: 0 }} />
          {navigationItem?.addButtonLink && (
            <>
              <VerticalDivider />
              <IconButton
                color="primary"
                onClick={onNavigateToAddPage(navigationItem.addButtonLink)}
                disableRipple
                aria-label="add"
              >
                <AddIcon />
              </IconButton>
            </>
          )}
        </ListItemButton>
      </Box>
    </List>
  );
}

export default NavigationItemReact;
